import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { trackLogout } from "../../services/auth-tracking.service";
import { getLogger } from "../../utils/logger";

const logger = getLogger('logout-button');

interface LogoutButtonProps {
  /** Overrides the default pill styling — the desktop corner menu renders it as a menu item. */
  className?: string;
  role?: string;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({
  className = "button__logout",
  role,
}) => {
  const { logout, getAccessTokenSilently } = useAuth0();

  const handleLogout = async () => {
    try {
      // Track logout event before logging out
      const token = await getAccessTokenSilently();
      await trackLogout(token);
      logger.debug('Logout tracked successfully');
    } catch (error) {
      logger.error('Failed to track logout', error);
      // Continue with logout even if tracking fails
    }
    
    // Proceed with logout
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <button className={className} role={role} onClick={handleLogout}>
      Log Out
    </button>
  );
};
